import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

// interface ThreeStateCheckboxProps {
//   label: string;
//   value: boolean | null;
//   onChange: (value: boolean | null) => void;
// }

const ThreeStateCheckbox = ({ label, value, onChange }) => {
  const handleYesChange = (event) => {
    onChange(event.target.checked ? true : null);
  };

  const handleNoChange = (event) => {
    onChange(event.target.checked ? false : null);
  };

  return (
    <Box
      sx={{
        position: "relative",
        border: "1px solid rgba(0, 0, 0, 0.23)",
        borderRadius: "8px",
        padding: 0.5,
        paddingLeft: 2,
        paddingRight: 2,
      }}
    >
      <Typography
        component="label"
        style={{
          position: "absolute",
          top: 0,
          transform: "translateY(-50%)",
          backgroundColor: "white",
          padding: "0 4px",
          marginLeft: "10px",
          fontSize: "0.9rem",
          color: "rgba(0, 0, 0, 0.6)",
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
        }}
      >
        <FormControlLabel
          control={<Checkbox checked={value === true} onChange={handleYesChange} size="small" />}
          label="Yes"
          style={{ display: "flex", flexWrap: "nowrap" }}
        />
        <FormControlLabel
          control={<Checkbox checked={value === false} onChange={handleNoChange} size="small" />}
          label="No"
          style={{ display: "flex", flexWrap: "nowrap" }}
        />
      </Box>
    </Box>
  );
};

export default ThreeStateCheckbox;
